export default __webpack_public_path__ + "../staticImages/advent-door-bg-set.svg";